import { Seo } from "../../components/Seo";

export function Legal({ kind }: { kind: "mentions" | "privacy" }) {
  const title = kind === "mentions" ? "Mentions légales" : "Politique de confidentialité";
  const path = kind === "mentions" ? "/mentions-legales" : "/politique-confidentialite";
  return (
    <>
      <Seo title={title} path={path} />
      <section className="section">
        <article className="container-narrow prose prose-neutral max-w-none">
          <h1 className="h-hero">{title}</h1>
          <p className="mt-4 text-ink-500">À compléter depuis l'espace admin.</p>
        </article>
      </section>
    </>
  );
}
